import { NavLink, useNavigate } from 'react-router-dom'
import {
  LayoutDashboard,
  TrendingUp,
  Briefcase,
  ClockIcon,
  BookmarkIcon,
  Trophy,
  LogOut,
  Activity,
} from 'lucide-react'
import { useAuth } from '@/contexts/AuthContext'
import { formatCurrency } from '@/lib/utils'
import { cn } from '@/lib/utils'

const navItems = [
  { to: '/', icon: LayoutDashboard, label: 'Dashboard', end: true },
  { to: '/trade', icon: TrendingUp, label: 'Trade' },
  { to: '/portfolio', icon: Briefcase, label: 'Portfolio' },
  { to: '/history', icon: ClockIcon, label: 'History' },
  { to: '/watchlist', icon: BookmarkIcon, label: 'Watchlist' },
  { to: '/leaderboard', icon: Trophy, label: 'Leaderboard' },
]

export default function Sidebar() {
  const { user, logout } = useAuth()
  const navigate = useNavigate()

  const handleLogout = () => {
    logout()
    navigate('/login')
  }

  return (
    <aside className="w-60 flex-shrink-0 bg-[#1a1b1e] border-r border-white/[0.06] flex flex-col h-full">
      {/* Logo */}
      <div className="px-5 py-6 border-b border-white/[0.06]">
        <div className="flex items-center gap-2.5">
          <div className="w-8 h-8 bg-accent rounded-lg flex items-center justify-center flex-shrink-0">
            <Activity className="w-4 h-4 text-black" strokeWidth={2.5} />
          </div>
          <div>
            <div className="font-semibold text-sm tracking-tight">StockSim</div>
            <div className="text-[10px] text-white/30 font-mono">Virtual Trading</div>
          </div>
        </div>
      </div>

      {/* Nav */}
      <nav className="flex-1 px-3 py-4 space-y-0.5 overflow-y-auto">
        {navItems.map(({ to, icon: Icon, label, end }) => (
          <NavLink
            key={to}
            to={to}
            end={end}
            className={({ isActive }) =>
              cn(
                'flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-all',
                isActive
                  ? 'bg-accent/10 text-accent'
                  : 'text-white/50 hover:text-white hover:bg-white/[0.05]'
              )
            }
          >
            {({ isActive }) => (
              <>
                <Icon
                  className={cn('w-4 h-4 flex-shrink-0', isActive ? 'text-accent' : '')}
                  strokeWidth={isActive ? 2.5 : 2}
                />
                {label}
              </>
            )}
          </NavLink>
        ))}
      </nav>

      {/* User section */}
      {user && (
        <div className="px-3 pb-4 border-t border-white/[0.06] pt-4 space-y-3">
          <div className="px-3 py-2.5 rounded-lg bg-white/[0.04] space-y-1">
            <div className="text-[11px] text-white/30 uppercase tracking-wider font-medium">Balance</div>
            <div className="text-base font-semibold font-mono text-accent">
              {formatCurrency(user.virtual_balance)}
            </div>
            <div className="text-xs text-white/40 truncate">{user.username}</div>
          </div>

          <button
            onClick={handleLogout}
            className="flex items-center gap-2.5 w-full px-3 py-2 rounded-lg text-sm text-white/40 hover:text-white hover:bg-white/[0.05] transition-all"
          >
            <LogOut className="w-4 h-4" />
            Sign out
          </button>
        </div>
      )}
    </aside>
  )
}
